var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form-item',{staticClass:"input-limit clearfix",attrs:{"label":_vm.label}},[_c('div',{directives:[{name:"decorator",rawName:"v-decorator",value:([_vm.fieldkey, {
      validateTrigger: ['change', 'blur'],
      rules: [{
        required: _vm.required, message: _vm.$t('message[751]')
      },{
        validator: _vm.checkValue
      }],
      initialValue: _vm.input
    }]),expression:"[fieldkey, {\n      validateTrigger: ['change', 'blur'],\n      rules: [{\n        required: required, message: $t('message[751]')\n      },{\n        validator: checkValue\n      }],\n      initialValue: input\n    }]"}]},[_c('a-input',{staticClass:"fl",attrs:{"placeholder":_vm.placeholder,"maxlength":_vm.max},on:{"input":_vm.handleInput},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}}),_c('span',{staticClass:"text-num fl"},[_vm._v(_vm._s(_vm.count)+" / "+_vm._s(_vm.max))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }